/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skills_Is_InheritedInputs */

const en_tables_skills_is_inherited = /** @type {(inputs: Tables_Skills_Is_InheritedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inherited`)
};

const de_tables_skills_is_inherited = /** @type {(inputs: Tables_Skills_Is_InheritedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inherited`)
};

/**
* | output |
* | --- |
* | "Inherited" |
*
* @param {Tables_Skills_Is_InheritedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skills_is_inherited = /** @type {((inputs?: Tables_Skills_Is_InheritedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skills_Is_InheritedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skills_is_inherited(inputs)
	return de_tables_skills_is_inherited(inputs)
});